import React, { useRef } from 'react';

import { CountrySearchService } from 'services/countrySearchService';

import { timer } from 'helpers/utils';

import { PromoSearchBar } from './PromoSearchBar';

export const PromoCountrySearchBar = (props) => {
    const timerID = useRef(null);
    const searchRef = useRef(null);

    const search = (value) => {
        const term = value;
        const resultList = CountrySearchService.search(props.countries, value);

        props.setCountryList({
            countryList: resultList,
            query: term,
        });
    };

    const debouncedSearch = (value) => (timerID.current = timer(timerID.current, () => search(value)));

    return (
        <PromoSearchBar
            searchRef={searchRef}
            placeholder={props.placeholder}
            onChange={(e) => debouncedSearch(e.target.value)}
            onCloseButtonClick={(e) => props.toggleSearch(e, false)}
        />
    );
};
